export const MESSAGE_ATTACHMENT_IDS = "attachmentIds";
export const messagingConversationFetchingBusyStateName = "messaging/conversation-fetching";
